module.exports = __webpack_public_path__ + "static/ecommerce.62c44241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/industries/img/ecommerce.jpg
// module id = 559
// module chunks = 245523097761474